import { LogActions } from "../actions";

const initialState = {
  logs: {
    rows: [],
    rowCount: 1,
    pageCount: 1,
  },
};

export default function log(state = initialState, action) {
  switch (action.type) {
    case LogActions.ACTION_SAVE_LOGS:
      return {
        ...state,
        logs: action.payload,
      };
    case LogActions.ACTION_SAVE_LOGS_DETAILS:
      return {
        ...state,
        logsDetails: action.payload,
      };
    default:
      return state;
  }
}

export function getLogs(state) {
  return state.log.logs;
}

export function getDetailsLogs(state) {
  return state.log.logsDetails;
}
